/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Container,
  Typography,
  Box,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  IconButton
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import Swal from 'sweetalert2'
import AppColors from "utils/AppColors";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { LoadingButton } from '@mui/lab';
import SearchQueryDailog from 'sections/@dashboard/SearchQueryDailog';
import { useSnackbar } from 'notistack';
import EditUserModal from 'sections/@dashboard/user/EditUserModal';
import { Link as RouterLink } from 'react-router-dom';
import ProfileDialog from 'sections/@dashboard/user/ProfileDialog';
import { fNumber } from 'utils/formatNumber';
import CustomGridToolbar from 'components/CustomGridToolbar';
// ----------------------------------------------------------------------



export default function MonthlyPendingBonus() {
  // const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [modal, setModal] = useState({open:false, user:{}});
  const [sort, setSort] = useState({month:'', order:'asc'});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  const [query,setQuery] = useState({page_size:100,page:0});
  const [dailog,setDailog] = useState({open:false,query:"",});
  const [profileDialog,setProfileDialog] = useState({open:false,user:"",});


  useEffect(() => {
    getInitData();
  }, []);

  // const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));

  return (
    <Page title="Monthly user bonus">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Monthly User Bonus"
          links={[
            { name: 'Rewards', href: PATH_DASHBOARD.rewards.root },
            { name: 'Monthly bonus' },
          ]}
        />

        {!state.loading && state.error !=null && (
          <Card sx={{m:3}}>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}
        <Card>
          
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"end", width:"100%", padding:2}}>
            
            <FormControl sx={{ml:2,width:180}}>
              <InputLabel id="demo-simple-select-label2">Sort amount</InputLabel>
              <Select
                labelId="demo-simple-select-label2"
                label="Ranking total"
                value={sort.order}
                onChange={(e)=> setSort({...sort,order:e.target.value})}
              >
                {[
                  {v:'asc',n:"Ascending"},
                  {v:'desc',n:"Descending"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <LoadingButton loading={state.loading} onClick={()=> getInitData()}
              sx={{ml:2}} variant='outlined' color="secondary">
                Apply changes
            </LoadingButton> 
            
          </Box>

          <Box sx={{ height: 700, width: '100%' }}>
            <DataGrid
              rows={data.data}
              columns={[
                {
                  field: 'name',
                  headerName: 'Name',
                  width: 240,
                  editable: false,
                  renderCell: (params) => (
                    < >
                      <IconButton color="primary" onClick={()=> setProfileDialog({open:true,user:params.row})}>
                        <Iconify icon={'ph:user-thin'} size="small" sx={{width:25,height:25}} />
                      </IconButton>
                      <Typography variant="subtitle2" sx={{cursor:"pointer"}} noWrap>
                        {params.row.first_name} {params.row.last_name}
                      </Typography>
                    </>
                  ),
                  valueGetter: (params) => `${params.row.first_name} ${params.row.last_name}`
                },
                {
                  field: 'amount',
                  headerName: 'Amount (NGN)',
                  width: 200,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                },
              
              ]}
              
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
              disableSelectionOnClick

              // pagination={false}
              paginationMode="server"
              rowCount={data.total_size}
              page={data.current_page - 1}
              rowsPerPage={data.data.length}
              onPageChange={(newPage)=> {
                setQuery({...query, page:newPage + 1});
                getInitData(newPage + 1);
              }}
              pageSize={data.page_size}
              onPageSizeChange={(newPage) => setQuery({...query, page_size:newPage})}
              rowsPerPageOptions={[]}
              
            />
          </Box>

        </Card>
      </Container>


     {modal.open &&  <EditUserModal
        open={modal.open}
        user={modal.user}
        handleClose={()=>{
          setModal({open:false});
        }}
        handleComplete={()=>{
          setModal({open:false});
          getInitData();
        }}
         />}


      {profileDialog.open &&  <ProfileDialog
        user={profileDialog.user}
        handleClose={()=>{
          setProfileDialog({open:false});
        }}
         />}

    </Page>
  );

  async function getInitData(page = null) {
    
    if(data.data.length > 0){
      setData({...data,data:[]});
    }
    setState({...state,loading:true,loadComplete:false,error:null});

    try {
      let str = `?month=${sort.month}&sort_order=${sort.order}`;
        str+= `&page=${page || query.page}&&page_size=${query.page_size}`;

      const response = await axios.get(CRUD.rewards.monthlyBonus+str);

      if (isMountedRef.current) {
        setData(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };

}
